import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import ExpeditionDetailPage from '@app/pages/carrier/expedition-detail/ExpeditionDetailPage.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

interface ComponentProps {
}

const CarrierExpeditionDetailPage: React.FC<ComponentProps> = () => {
  const { t } = useTranslation('common');
  return (
    <ResponsiveLayout title={t(`ShipmentDetail.demandsDetail`, `Demands detail`)}>
      <ExpeditionDetailPage />
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(CarrierExpeditionDetailPage);
